import { render } from "./InterestList.vue?vue&type=template&id=612651cd&scoped=true"
import script from "./InterestList.vue?vue&type=script&lang=ts"
export * from "./InterestList.vue?vue&type=script&lang=ts"

import "./InterestList.vue?vue&type=style&index=0&id=612651cd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-612651cd"

export default script